// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5PbKz","footer":"styles_footer__2TsSl"};